import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FilterCriteria } from '@woolworthsnz/trader-api';
import { SelectOptionComponent, SelectComponent } from '@woolworthsnz/form';
import { SearchMediatorService } from '../search-mediator.service';
import { SearchFilterKeys } from '../enums';
import { FilterDisclaimerComponent } from '../filter-disclaimer/filter-disclaimer.component';
import { NgFor, NgIf } from '@angular/common';

@Component({
	// tslint:disable-next-line:component-selector
	selector: 'search-filter-group',
	template: `
		<form-select multiple [label]="groupName" (onChange)="handleOnChange($event)" [selected]="selectedFilterValues">
			<form-select-option *ngFor="let facet of group" [value]="facet.value">
				{{ facet.name }} <span class="fiter-product-count">({{ facet.productCount }})</span>
			</form-select-option>
			<form-select-option [note]="true" *ngIf="canShowDisclaimer(group[0])">
				<search-filter-disclaimer></search-filter-disclaimer>
			</form-select-option>
		</form-select>
	`,
	styleUrls: ['./filter-group.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
	imports: [SelectComponent, NgFor, SelectOptionComponent, NgIf, FilterDisclaimerComponent],
})
export class FilterGroupComponent {
	selectedFilterValues: string[];

	private _group: FilterCriteria[] = [];
	private _selectedFilters: FilterCriteria[];

	constructor(private searchMediatorService: SearchMediatorService) {}

	get group(): FilterCriteria[] {
		return this._group;
	}

	get selectedFilters(): FilterCriteria[] {
		return this._selectedFilters;
	}

	get groupName(): string | undefined {
		return this.group[0]?.group;
	}

	@Input()
	set group(val: string | FilterCriteria[]) {
		if (typeof val === 'string') {
			this._group = JSON.parse(val) as FilterCriteria[];
		} else {
			this._group = val;
		}
	}

	@Input()
	set selectedFilters(filters: FilterCriteria[]) {
		this._selectedFilters = filters;
		this.selectedFilterValues = filters.map((filter) => filter.value);
	}

	canShowDisclaimer = (filter: FilterCriteria): boolean => filter?.key === SearchFilterKeys.PiesAttributes;

	handleOnChange = (selectedFilterValues: string[]): void => {
		const selectedFilters = this.group.filter((filter: any) => selectedFilterValues.indexOf(filter.value) !== -1);
		const otherGroupSelctedFilters = (this._selectedFilters || []).filter(
			(filter) => filter.group !== this.groupName
		);
		const totalFilters = [...selectedFilters, ...otherGroupSelctedFilters];
		this.searchMediatorService.emitFilterSelectEvent(totalFilters);
	};
}
